import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SupervisedUserCircleRoundedIcon from '@mui/icons-material/SupervisedUserCircleRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';

export const ROLES_ICONS = {
  supervisor: SupervisedUserCircleRoundedIcon,
  operator: AccountCircleRoundedIcon,
  admin: AdminPanelSettingsRoundedIcon,
  config: ManageAccountsRoundedIcon,
  reader: VisibilityRoundedIcon,
  accounting: AccountBalanceIcon,
  superadmin: ManageAccountsIcon,
};

export const PWD_DEFAULT = 'ChangeIt!1';

export const DEFAULT_SERVICE = 'CRM-BASE-MODULE';

export const USERS_SORTING = [
  { label: 'NAME', value: 'name', isDefault: true },
  { label: 'CREATEDON', value: 'createdOn' },
  { label: 'PHONE', value: 'phoneNumber' },
];
